// extracted by mini-css-extract-plugin
module.exports = {"item-centered":"result-item_item-centered__2wvTN"};